module.exports = __webpack_public_path__ + "static/media/rom2.6d597f0d.jpg";